// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdk-overlay-pane.my-dialog {
  position: relative !important;
}
.close.mat-button {
  top: 0;
  right: 0;
  padding: 5px;
  line-height: 14px;
  min-width: auto;
}

/* Tree Styling */
.tree-conntainer {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.zoom-btn {
  box-shadow: 1px 1px 4px 0px rgb(0 0 0 / 20%);
  font-size: 14px;
  margin: 5px;
  border: none;
  padding: 5px 13px;
  background: #6e5eff;
  color: #fff;
  border-radius: 5px;
}

.genealogy-scroll::-webkit-scrollbar {
  width: 5px;
  height: 20px;
}

.genealogy-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #e4e4e4;
}

.genealogy-scroll::-webkit-scrollbar-thumb {
  background: #212121;
  border-radius: 10px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.genealogy-scroll::-webkit-scrollbar-thumb:hover {
  background: #d5b14c;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.grabbable {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
}

.grabbable:active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.genealogy-body {
  white-space: nowrap;
  overflow-x: auto;
  /* padding: 50px; */
  padding-top: 10px;
  padding-bottom: 80px;
  text-align: center;
}

.genealogy-tree {
  margin-top: 12rem;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.genealogy-tree ul {
  padding-top: 20px;
  position: relative;
  padding-left: 0px;
  display: flex;
  justify-content: center;
}

.genealogy-tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;
}

.genealogy-tree li::before,
.genealogy-tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 3px solid #d5b14c;
  width: 50%;
  height: 18px;
}

.genealogy-tree li::after {
  right: auto;
  left: 50%;
  border-left: 3px solid #d5b14c;
}

.genealogy-tree li:only-child::after,
.genealogy-tree li:only-child::before {
  display: none;
}

.genealogy-tree li:only-child {
  padding-top: 0;
}

.genealogy-tree li:first-child::before,
.genealogy-tree li:last-child::after {
  border: 0 none;
}

.genealogy-tree li:last-child::before {
  border-right: 3px solid #d5b14c;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.genealogy-tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

.genealogy-tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 3px solid #d5b14c;
  width: 0;
  height: 20px;
}

.genealogy-tree li a {
  text-decoration: none;
  color: #666;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  display: inline-block;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

.close{
    background-color: unset !important;
    font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/video-tree/video-tree.component.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;AACA;EACE,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EAEZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAEhB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB","sourcesContent":[".cdk-overlay-pane.my-dialog {\n  position: relative !important;\n}\n.close.mat-button {\n  top: 0;\n  right: 0;\n  padding: 5px;\n  line-height: 14px;\n  min-width: auto;\n}\n\n/* Tree Styling */\n.tree-conntainer {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.zoom-btn {\n  box-shadow: 1px 1px 4px 0px rgb(0 0 0 / 20%);\n  font-size: 14px;\n  margin: 5px;\n  border: none;\n  padding: 5px 13px;\n  background: #6e5eff;\n  color: #fff;\n  border-radius: 5px;\n}\n\n.genealogy-scroll::-webkit-scrollbar {\n  width: 5px;\n  height: 20px;\n}\n\n.genealogy-scroll::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: #e4e4e4;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb {\n  background: #212121;\n  border-radius: 10px;\n  transition: 0.5s;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb:hover {\n  background: #d5b14c;\n  transition: 0.5s;\n}\n\n.grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.genealogy-body {\n  white-space: nowrap;\n  overflow-x: auto;\n  /* padding: 50px; */\n  padding-top: 10px;\n  padding-bottom: 80px;\n  text-align: center;\n}\n\n.genealogy-tree {\n  margin-top: 12rem;\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n}\n\n.genealogy-tree ul {\n  padding-top: 20px;\n  position: relative;\n  padding-left: 0px;\n  display: flex;\n  justify-content: center;\n}\n\n.genealogy-tree li {\n  float: left;\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: 20px 5px 0 5px;\n}\n\n.genealogy-tree li::before,\n.genealogy-tree li::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 50%;\n  border-top: 3px solid #d5b14c;\n  width: 50%;\n  height: 18px;\n}\n\n.genealogy-tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 3px solid #d5b14c;\n}\n\n.genealogy-tree li:only-child::after,\n.genealogy-tree li:only-child::before {\n  display: none;\n}\n\n.genealogy-tree li:only-child {\n  padding-top: 0;\n}\n\n.genealogy-tree li:first-child::before,\n.genealogy-tree li:last-child::after {\n  border: 0 none;\n}\n\n.genealogy-tree li:last-child::before {\n  border-right: 3px solid #d5b14c;\n  border-radius: 0 5px 0 0;\n  -webkit-border-radius: 0 5px 0 0;\n  -moz-border-radius: 0 5px 0 0;\n}\n\n.genealogy-tree li:first-child::after {\n  border-radius: 5px 0 0 0;\n  -webkit-border-radius: 5px 0 0 0;\n  -moz-border-radius: 5px 0 0 0;\n}\n\n.genealogy-tree ul ul::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border-left: 3px solid #d5b14c;\n  width: 0;\n  height: 20px;\n}\n\n.genealogy-tree li a {\n  text-decoration: none;\n  color: #666;\n  font-family: arial, verdana, tahoma;\n  font-size: 11px;\n  display: inline-block;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n}\n\n.close{\n    background-color: unset !important;\n    font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
